/**
 * Короткий номер модема — тот, которым его называют владелец и клиент.
 *
 * ЗАЧЕМ. У нодовых прокси `router_id` это база плюс слот: модем №2 записан как
 * 1000000002. В интерфейсе показывали именно его — длинный, нечитаемый и людям
 * ничего не говорящий. Клиент знает свой модем как «№2», в переписке называет
 * «двойку», и админ должен видеть то же самое.
 *
 * У старых (legacy) прокси слота нет, а `router_id` короткий сам по себе —
 * их показываем как есть.
 *
 * Порядок: сначала `slot` из ответа API, если он там есть; иначе выводим из
 * `router_id`. Второе нужно там, где слот не приходит — например в истории
 * покупок, где хранится только `router_id`.
 */
export const ROUTER_ID_BASE = 1_000_000_000;

export function proxyNumber(source: {
    slot?: number | null,
    router_id?: number | null
} | null | undefined): string {
    if (!source) return "—";
    if (source.slot !== null && source.slot !== undefined) {
        return String(source.slot);
    }
    const id = source.router_id;
    if (id === null || id === undefined) return "—";
    return String(id >= ROUTER_ID_BASE ? id - ROUTER_ID_BASE : id);
}
